module.exports = __webpack_public_path__ + "img/converge.0d77ee1d.svg";